import { render, staticRenderFns } from "./UnloadingAddress.vue?vue&type=template&id=639d57e1"
import script from "./UnloadingAddress.vue?vue&type=script&lang=js"
export * from "./UnloadingAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports